import React from "react";
import "./LogoutConfirmation.css";

const LogoutConfirmation = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="logout-modal-overlay" onClick={onClose}>
      <div className="logout-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="logout-modal-icon">
          <i className="ph ph-sign-out" />
        </div>
        <h3 className="logout-modal-title">Logout Confirmation</h3>
        <p className="logout-modal-text">Are you sure you want to logout?</p>
        <div className="logout-modal-actions">
          <button className="logout-modal-btn logout-modal-btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="logout-modal-btn logout-modal-btn-confirm" onClick={onConfirm}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmation;
